
import './LinkCard.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLink } from '@fortawesome/free-solid-svg-icons'


export default function LinkCard(props) {
    return (
        <a
            href={props.url}
            className={'linkcard noselect ' + props.className}
            style={{ textDecoration: 'none', color: 'inherit' }}
        >

            <FontAwesomeIcon className='linkcardicon' icon={faLink} />
            <div className='linkcardtextcont'>
                <b>{props.title}</b>
                {/* <p>{props.datum} ● {props.description}</p> */}
                <p>{props.description}</p>
            </div>

        </a>
    )
}
